<template>
  <section>
    <div class="hidden">
      <Checkbox
        v-model="value"
        :inputId="item.uuid?.concat(item?.keywordRank)"
        :value="item"
        @change="onSelect(item)"
      />
    </div>
    <div
      :class="`flex items-center gap-3 py-1 px-3 rounded-full transition-all duration-200 cursor-pointer ${
        item?.isEval
          ? 'bg-h-primary-700 text-white border'
          : 'bg-white text-h-primary-700 flex-row-reverse border border-h-primary-400'
      } hover:bg-h-secondary-200 hover:text-h-secondary-800 hover:border-h-secondary-900`"
    >
      <label
        class="flex gap-2 items-center cursor-pointer"
        :for="item.uuid?.concat(item?.keywordRank)"
      >
        <p>{{ item.keyword }}</p>
        <v-icon
          :name="`${item?.isEval ? 'fa-regular-times-circle' : 'hi-plus-sm'}`"
          class="hover:scale-110 transition-all"
        />
      </label>
    </div>
  </section>
</template>

<script lang="ts">
import { defineComponent, PropType } from "vue";

export default defineComponent({
  name: "keywordsBlacklist",
  emits: ["onSelect", "update:selected"],
  props: {
    selected: {
      type: Array as PropType<any>,
      default: [],
    },
    item: {
      type: Object as PropType<any>,
      default: {},
    },
  },
  computed: {
    value: {
      get() {
        return this.selected;
      },
      set(value) {
        this.$emit("update:selected", value);
      },
    },
  },
  methods: {
    onSelect(event): void {
      this.$emit("onSelect", event);
    },
  },
});
</script>
